import React from 'react';
import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="footer site-footer">
      <div className="container">
        <div className="columns">
          <div className="column is-3">
            <h4 className="footer-heading">Product</h4>
            <ul className="footer-links">
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/games">Games</Link></li>
              <li><a href="https://docs.sitechesports.com" target="_blank" rel="noopener noreferrer">Documentation</a></li>
            </ul>
          </div>
          <div className="column is-3">
            <h4 className="footer-heading">Company</h4>
            <ul className="footer-links">
              <li><Link to="/about">About</Link></li>
              <li><Link to="/news">News</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className="column is-3">
            <h4 className="footer-heading">Legal</h4>
            <ul className="footer-links">
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
            </ul>
          </div>
          <div className="column is-3">
            <h4 className="footer-heading">Follow Us</h4>
            <div className="footer-socials">
              <a href="https://linkedin.com/company/sitech-esports/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <i className="fa-brands fa-linkedin fa-lg"></i>
              </a>
              <a href="https://www.instagram.com/sitechesports/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <i className="fa-brands fa-instagram fa-lg"></i>
              </a>
            </div>
            <p className="footer-tagline mt-4">Simulation-powered pricing for esports betting</p>
          </div>
        </div>
        <div className="has-text-centered mt-5 pt-5 footer-bottom">
          <p>&copy; 2026 Sitech eSports. All rights reserved.</p>
          <p className="mt-2" style={{ fontSize: '0.8rem', color: '#888' }}>
            Sitech eSports Ltd — Registered in England &amp; Wales (Company No. 16950192). B2B technology provider only — not a gambling operator.
          </p>
        </div>
      </div>
    </footer>
  );
}
